export const routes = [
  {
    path: '/',
    redirect: '/app/dashboard',
  },
  {
    path: '/start',
    component: () => import(/* webpackChunkName: "" */ '../views/AppStart.vue'),
    children: [
      {
        path: '/signup',
        name: 'signup',
        component: () =>
          import(/* webpackChunkName: "" */ '../views/Signup/Signup.vue'),
      },
      {
        path: '/login',
        name: 'login',
        component: () =>
          import(/* webpackChunkName: "" */ '../views/Login/Login.vue'),
      },
      {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () =>
          import(/* webpackChunkName: "" */ '../views/ForgotPassword.vue'),
      },
      {
        path: '/reset-password/:uid/:token',
        name: 'reset-password',
        component: () =>
          import(/* webpackChunkName: "" */ '../views/ResetPassword.vue'),
      },
      {
        path: '/confirm-account/:token',
        name: 'confirm-account',
        component: () =>
          import(/* webpackChunkName: "" */ '../views/ConfirmAccount.vue'),
      },
      {
        path: '/confirm-invitation/:token',
        name: 'confirm-invitation',
        component: () =>
          import(/* webpackChunkName: "" */ '../views/ConfirmInvitation.vue'),
      },
    ],
  },
  {
    path: '/my-account',
    name: 'my-account',
    component: () =>
      import(/* webpackChunkName: "" */ '../views/MyAccount/MyAccount.vue'),
    meta: { private: true },
  },
  {
    path: '/company-create',
    name: 'company-create',
    component: () =>
      import(
        /* webpackChunkName: "" */ '../views/CompanyCreate/CompanyCreate.vue'
      ),
    meta: { private: true },
  },
  {
    path: '/segment-create',
    name: 'segment-create',
    component: () =>
      import(
        /* webpackChunkName: "" */ '../views/SegmentCreate/SegmentCreate.vue'
      ),
    meta: { private: true },
  },
  {
    path: '/admin',
    component: () =>
      import(/* webpackChunkName: "" */ '../views/Admin/Admin.vue'),
    meta: { private: true },
    children: [
      {
        path: 'general',
        name: 'admin-general',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/Admin/pages/AdminGeneral/AdminGeneral.vue'
          ),
      },
      {
        path: 'users',
        name: 'admin-users',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/Admin/pages/AdminUsers/AdminUsers.vue'
          ),
      },
      {
        path: 'domains',
        name: 'admin-domains',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/Admin/pages/AdminDomains/AdminDomains.vue'
          ),
      },
      {
        path: 'campaigns',
        name: 'admin-campaigns',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/Admin/pages/AdminCampaigns/AdminCampaigns.vue'
          ),
      },
      {
        path: 'parameters',
        name: 'admin-parameters',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/Admin/pages/AdminParameters.vue'
          ),
        children: [
          {
            path: 'custom',
            name: 'admin-parameters-custom',
            component: () =>
              import(
                /* webpackChunkName: "" */ '../views/Admin/pages/AdminSchema/AdminSchema.vue'
              ),
          },
          {
            path: 'marketer-data',
            name: 'admin-parameters-marketer',
            component: () =>
              import(
                /* webpackChunkName: "" */ '../views/Admin/pages/AdminMarketerData/AdminMarketerData.vue'
              ),
          },
        ],
      },

      {
        path: 'export',
        name: 'admin-export',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/Admin/pages/AdminExport/AdminExport.vue'
          ),
      },
    ],
  },
  {
    path: '/segment-admin',
    component: () =>
      import(
        /* webpackChunkName: "" */ '../views/AdminSegment/AdminSegment.vue'
      ),
    meta: { private: true },
    children: [
      {
        path: 'general',
        name: 'segment-admin-general',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/AdminSegment/pages/AdminSegmentGeneral/AdminSegmentGeneral.vue'
          ),
      },
      {
        path: 'schema',
        name: 'segment-admin-schema',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/AdminSegment/pages/AdminSegmentSchema/AdminSegmentSchema.vue'
          ),
      },
      {
        path: 'campaigns',
        name: 'segment-admin-campaigns',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/AdminSegment/pages/AdminSegmentCampaigns/AdminSegmentCampaigns.vue'
          ),
      },
      {
        path: 'export',
        name: 'segment-admin-export',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/AdminSegment/pages/AdminSegmentExport/AdminSegmentExport.vue'
          ),
      },
    ],
  },
  {
    path: '/app',
    name: 'app-main',
    component: () =>
      import(/* webpackChunkName: "" */ '../views/AppMain/AppMain.vue'),
    meta: { private: true },
    children: [
      {
        path: 'create-link/success',
        name: 'create-link-success',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/CreateLinkSuccess/CreateLinkSuccess.vue'
          ),
      },
      {
        path: 'create-link/:linkId?',
        name: 'create-link',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/CreateLink/CreateLink.vue'
          ),
        props: (route) => ({ linkId: Number(route.params.linkId) }),
      },
      {
        path: 'create-link-from-template/:templateId',
        name: 'create-link-from-template',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/CreateLink/CreateLink.vue'
          ),
        props: (route) => ({ templateId: Number(route.params.templateId) }),
      },
      {
        path: 'start-link-from-template',
        name: 'start-link-from-template',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/StartLinkFromTemplate.vue'
          ),
      },
      {
        path: 'edit-template/:templateId?',
        name: 'edit-template',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/EditTemplate/EditTemplate.vue'
          ),
        props: (route) => ({ templateId: Number(route.params.templateId) }),
      },
      {
        path: 'dashboard',
        component: () =>
          import(/* webpackChunkName: "" */ '../views/Dashboard/Dashboard.vue'),
        children: [
          {
            path: '',
            name: 'dashboard-links',
            component: () =>
              import(
                /* webpackChunkName: "" */ '../views/DashboardLinks/DashboardLinks.vue'
              ),
          },
          {
            path: 'campaigns',
            name: 'dashboard-campaigns',
            component: () =>
              import(
                /* webpackChunkName: "" */ '../views/DashboardCampaigns/DashboardCampaigns.vue'
              ),
          },
        ],
      },
    ],
  },
  {
    path: '*',
    redirect: '/login',
  },
];
